export class RecordVm {
  public propertyId: string;
  public displayName: string;
  public value: string;
  public origin: string;
  public type: string;
  public created: string;
  public modified: string;

  public constructor(data?: any) {
    this.propertyId = (data && data.propertyId) ? data.propertyId : null;
    this.displayName = (data && data.displayName) ? data.displayName : null;
    this.value = (data && data.value) ? data.value : null;
    this.origin = (data && data.origin) ? data.origin : null;
    this.type = (data && data.type) ? data.type : null;
    this.created = (data && data.created) ? data.created : null;
    this.modified = (data && data.modified) ? data.modified : null;
  }
}
